var map = {
	"./de.json": [
		"GkOR",
		20
	],
	"./en.json": [
		"cCmO",
		21
	],
	"./es.json": [
		"qgB8",
		22
	],
	"./it.json": [
		"2WN/",
		23
	],
	"./ja.json": [
		"fpnu",
		24
	],
	"./nl.json": [
		"5dWb",
		25
	],
	"./pt.json": [
		"v0ES",
		26
	],
	"./pt_BR.json": [
		"+ZGd",
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Zbgq";
module.exports = webpackAsyncContext;